export default {"src":"/_next/static/media/v3-cat-icon.145f83e1.svg","height":48,"width":48};